module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-kpito-01@2x.13bf30ad.jpg";